import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { PaymentMethodSetting, PaymentMethodSettingsResponse } from '../entities';

@Injectable({
    providedIn: 'root'
})
export class PaymentMethodSettingsDataService {
    private readonly http = inject(HttpClient);

    private readonly url = '/rest/default-settings/payment-method-settings';

    getPaymentMethodSettings(): Observable<PaymentMethodSettingsResponse> {
        return this.http.get<PaymentMethodSettingsResponse>(`${environment.apiUrl}${this.url}`);
    }

    updatePaymentMethodSettings(paymentMethodSettings: PaymentMethodSetting[]): Observable<void> {
        return this.http.put<void>(`${environment.apiUrl}${this.url}/update`, { paymentMethodSettings });
    }
}
